import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import styles from './SummaryCard.module.css';

const SummaryCard = ({ icon, label, value, trend, trendType, iconBg }) => {
  return (
    <div className={styles['summary-card']}>
      <div className={styles['card-header']}>
        <div className={styles['icon-wrapper']} style={{ backgroundColor: iconBg }}>
          {icon}
        </div>
        {trend && (
          <div className={`${styles['trend-badge']} ${trendType}`}>
            {trendType === 'up' && <TrendingUp size={12} />}
            {trendType === 'down' && <TrendingDown size={12} />}
            <span>{trend}</span>
          </div>
        )}
      </div>
      <div className={styles['card-body']}>
        <span className={styles['card-label']}>{label}</span>
        <h2 className={styles['card-value']}>{value}</h2>
      </div>
    </div>
  );
};

export default SummaryCard;
